<template>
  <div>
    <!-- VUE ADMIN -->
    <div v-if="isPromoteur && isAdmin">
      <spinner-round
        :is-loading="loading || forceLoading"
        v-if="loading || forceLoading"></spinner-round>
      <div v-if="reservation && lot && program && !loading">
        <page-nav-bar
          :is-sticky="true"
          :back-button="true"
          :has-actions="false"
          :no-margin-bottom="true"
          :hide-separators="true">
          <h1 slot="title">
            <span
              class="">Passage en pré-réservation</span>
            <span class="has-text-weight-bold">
              <router-link
                class="is-paddingless"
                :to="{'name': 'LotVue', params: {id: lot.pk}}"
                v-if="lot && lot.pk">
                - Lot {{ lot.ref }}
              </router-link>
            </span>
          </h1>
          <router-link
            slot="subtitle"
            :to="{'name': 'ProgramVue', params: {id: program.pk}}"
            v-if="program && program.pk">
            / {{ program.name }}
          </router-link>
          <span
            slot="label"
            v-if="isDistributeur">- {{ program.promoteur.name }}</span>
        </page-nav-bar>
        <page-content :has-no-padd-on-act-on-desktop="false">
          <div class="is-flex is-padding-left-small is-padding-right-small is-minH50p">
            <div class="is-self-centered">
              <div
                class="title is-6">
                <span class="is-uppercase has-text-weight-medium">Merci de renseigner les informations attendues (<span class="icon is-small"><i class="fas fa-check-circle"></i></span>) pour valider la réservation du lot :</span>
              </div>
            </div>
          </div>
          <div
            v-if="contractName"
            class="columns is-gapless is-marginless has-background-white is-minH64p is-margin-top-small is-border">
            <div class="column columns is-self-centered is-padding-left">
              <div
                class="column is-narrow is-flex is-padding-small is-margin-right-large is-margin-left-large">
                <span
                  class="icon is-self-centered">
                  <i class="fa-3x fal fa-folder-open"></i>
                </span>
              </div>
              <div
                class="is-margin-left-large column is-padding-left-small is-self-centered columns is-gapless is-vcentered is-marginless">
                <span class="is-5 has-text-weight-bold is-uppercase">
                  Modèle:
                </span>
                <span class="is-5 is-padding-left-xsmall">
                  {{ contractName }}
                </span>
              </div>
            </div>
            <div
              class="column is-self-centered  is-4 is-narrow is-padding-right-xsmall">
              <a
                @click="openPreviewContractSelect"
                class="button is-light is-border is-small is-uppercase is-fullwidth is-radius is-minH50p">
                <span>Changer le modèle de contrat</span>
              </a>
            </div>
          </div>
          <div class="columns is-gapless is-marginless has-background-white is-minH64p is-margin-top-xxsmall is-margin-bottom-small ">
            <adv-lot-compact
              :row-mode="true"
              :for-pre-resa="true"
              v-if="lot && program"
              :lot="lot"
              :program="program"
              :display-button="isAdmin && isPromoteur"
              :show-specifications="false" />
          </div>
          <div class="columns is-variable is-2 is-multiline is-margin-bottom">
            <div class="column is-12 is-7-widescreen is-7-fullhd is-paddingless-bottom">
              <div class="has-background-light is-border">
                <div
                  v-if="(isEditing || isRefused) || reservation.comment"
                  v-scroll-to="'#commentary-preresa'"
                  class="has-background-primary is-fullwidth is-flex-between has-text-white is-padding-top-small is-padding-bottom-small has-cursor-pointer">
                  <div class="has-text-weight-semibold is-flex-center">
                    <div
                      class="is-flex-center comment-icon">
                      <span
                        v-if="reservation.comment"
                        :style="`border-color: #24323B`"
                        class="orange-bullet"></span>
                      <span
                        class="icon is-size-3 icon-margin">
                        <i class="fas fa-sticky-note"></i>
                      </span>
                    </div>
                    <span class="is-margin-left-xsmall">Commentaire</span>
                    <span class="is-margin-left-xxsmall">{{ reservation.comment ? '(1)': '(0)' }}</span>
                  </div>
                  <div class="is-underline is-size-6 is-margin-right">
                    <i>Ajouter un commentaire</i>
                  </div>
                </div>
                <div class="is-padding is-border-top">
                  <div class="columns has-background-light">
                    <div class="column">
                      <div class="columns is-gapless has-text-primary">
                        <div class="column is-4">
                          <r-label
                            :label="'VENDEUR / MANDATAIRE'"
                            :is-required="false"></r-label>
                          <span class="has-text-weight-medium">{{ seller.first_name }} {{ seller.last_name }}</span>
                          <br>
                          <div
                            v-if="reservation.account && currentUser.pk !== reservation.seller_data.pk"
                            class="is-padding-top-xxsmall">
                            <span class="is-size-5">Société : </span>
                            <router-link :to="{name: 'CompanyVue', params: {id: reservation.account.pk}}">
                              <span class="is-underline">{{ reservation.account.name }}</span>
                            </router-link>
                          </div>
                        </div>
                        <div class="column is-5">
                          <div
                            v-if="isPromoteurAdmin && !isPending">
                            <div class="is-margin-bottom-xsmall">
                              <r-label
                                v-if="errors.has('remuneration')"
                                :label="`Taux de commercialisation`"
                                :is-required="false"
                                :red-check="true"></r-label>
                              <r-label
                                v-else
                                :label="`Taux de commercialisation`"
                                :red-check="true"
                                :is-required="false"
                                :value="reservation.seller_remuneration"></r-label>
                            </div>
                            <div class="field has-addons is-margin-bottom-xxsmall">
                              <v-input
                                id="remuneration"
                                :name="'remuneration'"
                                :classes-input="'is-active is-input'"
                                :has-incrementations="true"
                                input-type="number"
                                :disabled="!isPromoteurAdmin"
                                @input="remunerationInput($event)"
                                :model="reservation.seller_remuneration"
                                :has-addons="true"
                                :max="100"
                                :step="1"
                                :number="true"
                                v-validate="'decimal:2'"
                                :errors-bag="errors"
                                data-vv-value-path="val"
                                data-vv-as=" ">
                                <p
                                  class="control"
                                  slot="addonRight">
                                  <a class="button is-border is-square is-static">
                                    <span class="icon"><i class="fas fa-percentage"></i></span>
                                  </a>
                                </p>
                              </v-input>
                            </div>
                          </div>
                          <div
                            v-else-if="isPromoteurAdmin && isPending">
                            <div class="is-margin-bottom-xsmall">
                              <r-label
                                v-if="errors.has('remuneration')"
                                :label="`Taux de commercialisation`"
                                :red-check="true"></r-label>
                              <r-label
                                v-else
                                :label="`Taux de commercialisation`"
                                :red-check="true"
                                :value="reservation.seller_remuneration"></r-label>
                            </div>
                            <div
                              style="width: 110px"
                              class="field has-addons is-margin-bottom-xxsmall">
                              <p class="control is-expanded">
                                <v-input
                                  id="remuneration"
                                  :name="'remuneration'"
                                  :classes-input="'is-active is-input'"
                                  :has-incrementations="true"
                                  input-type="number"
                                  :disabled="!isPromoteurAdmin"
                                  @input="remunerationInput($event)"
                                  :model="reservation.seller_remuneration"
                                  :has-addons="true"
                                  :max="100"
                                  :step="1"
                                  :number="true"
                                  v-validate="'decimal:2'"
                                  :errors-bag="errors"
                                  data-vv-value-path="val"
                                  data-vv-as=" ">
                                </v-input>
                              </p>
                              <p class="control">
                                <a class="button is-border is-square is-static">
                                  <span class="icon"><i class="fas fa-percentage"></i></span>
                                </a>
                              </p>
                            </div>
                          </div>
                          <span class="has-text-weight-light is-italic is-size-6">Taux de commercialisation {{ seller.account_type === 'promoteur' ? '' : 'du mandat' }} : {{ reservation.seller_remuneration }} %</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="is-margin-top-small">
                <div
                  style="margin-bottom: 0; justify-content: flex-end"
                  class="columns is-gapless is-mobile has-background-white is-minH50p is-border">
                  <div
                    id="dropdownMenuActions"
                    class="dropdown is-hoverable is-right">
                    <div class="dropdown-trigger is-flex">
                      <button
                        aria-haspopup="true"
                        aria-controls="dropdown-menu"
                        style="padding-left: 5rem; padding-right: 5rem"
                        class="page-header-btn page-header-btn--separetedIco-right is-widthFixToHeaderAccount is-small is-secondary">
                        <span>Ajouter Co-Acquéreur</span>
                      </button>
                    </div>
                    <div
                      id="dropdown-menu"
                      role="menu"
                      class="dropdown-menu">
                      <div class="dropdown-content is-paddingless">
                        <a
                          v-if="canAdd"
                          @click="openBuyerSelection"
                          class="dropdown-item">
                          <span class="icon is-medium">
                            <i class="fas fa-users"></i>
                          </span>
                          <span class="is-margin-left-xsmall">Sélectionner un co-acquéreur</span>
                        </a>
                        <a
                          v-if="canAdd"
                          @click="openNewContactQuickview({}, null, null, null, true)"
                          class="dropdown-item">
                          <span class="icon is-medium">
                            <i class="fas fa-users-medical"></i>
                          </span>
                          <span class="is-margin-left-xsmall">Créer un co-acquéreur</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <template>
                  <div
                    v-for="(buyer, index) in buyers"
                    :key="buyer.pk">
                    <membre-pre-resa
                      class="has-background-white is-margin-bottom-xxsmall"
                      :class="index > 0 ? 'is-border' : 'is-border-bottom is-border-left is-border-right'"
                      :for-pre-resa="true"
                      :is-grey="true"
                      :membre="buyer"
                      @updateContact="openModalContactPreResaInfo"
                      @deleteCobuyer="deleteBuyer"
                      @deleteDocument="deleteDocument"
                      :is-co-acquereur="index > 0"
                      :is-membre-promoteur="false"
                      :modal-promoteur="false"
                      :can-edit="(currentUser.account.pk === buyer.account.pk || currentUser.pk === buyer.user.pk) && (isEditing || isRefused)">
                    </membre-pre-resa>
                  </div>
                </template>
                <div class="is-border columns is-gapless is-margin-bottom-xxsmall">
                  <div
                    v-if="reservation.notary_details.use_buyer_notary"
                    class="column is-narrow is-flex is-padding-small"
                    :class="validNotary ? 'has-background-success' : 'has-background-white--darken1 tooltip is-tooltip-right'"
                    :data-tooltip="'Notaire client incomplet'">
                    <span
                      class="icon has-text-white is-self-centered"
                      :class="validNotary ? 'has-text-white' : 'has-text-danger'"><i
                        :class="validNotary ? 'fa-check-circle' : 'fa-exclamation-circle'"
                        class="fas"></i></span>
                  </div>
                  <div class="column has-background-white">
                    <div
                      class="is-padding-left-small is-padding-right-small is-flex is-minH50p"
                      :class="!reservation.notary_details.use_buyer_notary ? 'has-background-white ' : ' has-background-dark'">
                      <div class="is-self-centered is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right">
                        <div>
                          <input
                            id="use_buyer_notary"
                            v-model="reservation.notary_details.use_buyer_notary"
                            name="use_buyer_notary"
                            class="switch is-success is-rounded"
                            type="checkbox">
                          <label
                            for="use_buyer_notary"
                            :class="!reservation.notary_details.use_buyer_notary ? '' : 'has-text-white'"
                            class="is-uppercase">Renseigner le notaire du client</label>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="!isPending && reservation.notary_details.use_buyer_notary"
                      class="is-border-top is-padding">
                      <div class="columns is-multiline">
                        <div class="column is-6">
                          <r-label
                            :label="reservation.notary_details.tiers_id ? 'Notaire du référentiel' : 'Rechercher un notaire au référentiel'"
                            :is-required="false"
                            :value="reservation.notary_details.tiers_id" />
                          <tiers-selector
                            :selected="selectedNotaireClient"
                            :slot-ref="reservation.notary_details"
                            :types="['notaire']"
                            placeholder="Nom, ville..."
                            @select="selectNotaireClient"
                            @unlink="unlinkNotaireClient" />
                        </div>
                        <div class="column is-6"></div>
                        <div class="column is-6">
                          <r-label
                            label="Nom du notaire"
                            :is-required="true"
                            :red-check="true"
                            :value="reservation.notary_details.name"></r-label>
                          <div class="control">
                            <v-input
                              id="reservation.notary_details.name"
                              :disabled="!!reservation.notary_details.tiers_id"
                              name="reservation.notary_details.name"
                              :model="reservation.notary_details.name"
                              v-validate="'min:2'"
                              @input="val => $store.commit('modifyCurrentReservation', { key: 'notary_details.name', value: val })"
                              :errors-bag="errors"
                              data-vv-value-path="val"
                              classes="input"
                              data-vv-as="Nom du notaire">
                            </v-input>
                          </div>
                        </div>
                        <div class="column is-6">
                          <r-label
                            label="Téléphone du notaire"
                            :is-required="true"
                            :red-check="true"
                            :value="reservation.notary_details.phone"
                            :truncate="false">
                            <span
                              class="is-padding-left-xsmall"
                              v-helper.right="'6BNfgrh0uP7V5UyMRsZvQp'">
                              <i class="fal fa-info-circle"></i>
                            </span>
                          </r-label>
                          <div class="control">
                            <v-input
                              id="reservation.notary_details.phone"
                              :disabled="!!reservation.notary_details.tiers_id"
                              name="reservation.notary_details.phone"
                              :model="reservation.notary_details.phone"
                              v-validate="'min:10'"
                              @input="val => $store.commit('modifyCurrentReservation', { key: 'notary_details.phone', value: val })"
                              :placeholder="'06xxxxxxxx / +336xxxxxxxx'"
                              :errors-bag="errors"
                              data-vv-value-path="val"
                              data-vv-as="Téléphone"
                              :has-addons="true">
                              <p
                                class="control"
                                slot="addonLeft">
                                <a class="button is-static is-square is-static">
                                  <span class="icon"><i class="fas fa-phone-office"></i></span>
                                </a>
                              </p>
                            </v-input>
                          </div>
                        </div>
                        <div class="column is-6">
                          <r-label
                            label="Email"
                            :value="reservation.notary_details.email"
                            :is-required="true"
                            :red-check="true"></r-label>
                          <div class="control">
                            <v-input
                              :has-addons="true"
                              id="reservation.notary_details.email"
                              :disabled="!!reservation.notary_details.tiers_id"
                              name="reservation.notary_details.email"
                              :model="reservation.notary_details.email"
                              v-validate="'email'"
                              :errors-bag="errors"
                              @input="val => $store.commit('modifyCurrentReservation', { key: 'notary_details.email', value: val })"
                              data-vv-value-path="val"
                              data-vv-as="Email">
                              <p
                                class="control"
                                slot="addonLeft">
                                <a class="button is-static is-square is-static">
                                  <span class="icon"><i class="fas fa-paper-plane"></i></span>
                                </a>
                              </p>
                            </v-input>
                          </div>
                        </div>
                        <div class="column is-12">
                          <address-input
                            v-if="!reservation.notary_details.tiers_id"
                            label="Adresse de correspondance"
                            @update="val => $store.commit('modifyCurrentReservation', { key: 'notary_details.address', value: val })"
                            :source="reservation.notary_details.address"
                            :is-required="true"
                            :red-check="true">
                          </address-input>
                          <div
                            v-else
                            class="columns is-multiline">
                            <div class="column is-6">
                              <r-label
                                label="Adresse de correspondance"
                                :is-required="false"
                                :value="tiersAddressResume(reservation.notary_details.address)" />
                              <input
                                :value="tiersAddressResume(reservation.notary_details.address)"
                                type="text"
                                class="input"
                                disabled>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-else-if="isPending && reservation.notary_details.use_buyer_notary"
                      class="is-border-top has-background-white is-padding">
                      <div class="columns is-multiline">
                        <span class="column is-12"><span class="label">Nom du notaire : </span><span v-if="'name' in reservation.notary_details && reservation.notary_details.name">{{ reservation.notary_details.name }}</span><span v-else>NC</span></span>
                        <span class="column is-12"><span class="label">Téléphone du notaire  : </span><span v-if="'phone' in reservation.notary_details && reservation.notary_details.phone">{{ reservation.notary_details.phone }}</span><span v-else>NC</span></span>
                        <span class="column is-12"><span class="label">Email du notaire : </span><span v-if="'email' in reservation.notary_details && reservation.notary_details.email">{{ reservation.notary_details.email }}</span><span v-else>NC</span></span>
                        <span class="column is-12"><span class="label">Adresse de correspondance : </span>
                          <span v-if="'address' in reservation.notary_details && reservation.notary_details.address && 'line1' in reservation.notary_details.address && 'city' in reservation.notary_details.address && 'zip_code' in reservation.notary_details.address && reservation.notary_details.address.zip_code && reservation.notary_details.address.city && reservation.notary_details.address.line1 ">{{ reservation.notary_details.address.line1 }} {{ reservation.notary_details.address.city }} {{ reservation.notary_details.address.zip_code }}</span><span v-else>NC</span></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="is-border is-padding is-margin-bottom-xxsmall has-background-light">
                  <div class="columns is-multiline">
                    <div class="column is-4">
                      <div class="is-margin-bottom-xsmall">
                        <r-label
                          :label="'Destination'"
                          :red-check="true"
                          :value="reservation.destination"></r-label>
                      </div>
                      <div class="control">
                        <div class="select is-fullwidth">
                          <select
                            class=""
                            @change="$store.commit('modifyCurrentReservation', { key: 'destination', value: reservation.destination })"
                            v-model="reservation.destination">
                            <option :value="null">
                              Sélectionner
                            </option>
                            <option
                              v-for="a in advDestinationsList"
                              :key="a.value"
                              :value="a.value">
                              {{ a.label }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <p
                        v-if="error.destination"
                        class="help is-danger">
                        Le champ est obligatoire
                      </p>
                    </div>
                    <div
                      v-if="reservation.destination === 'invest' || reservation.destination === 'main_residence'"
                      class="column is-4">
                      <div class="is-margin-bottom-xsmall">
                        <r-label
                          v-if="reservation.destination === 'invest'"
                          :label="'Dispositif'"
                          :red-check="true"
                          :value="reservation.tax_dispositif"></r-label>
                        <r-label
                          v-else-if="reservation.destination === 'main_residence'"
                          :is-required="false"
                          :label="'Dispositif'"
                          :no-check="true"
                          :value="reservation.tax_dispositif"></r-label>
                      </div>
                      <div>
                        <div class="control">
                          <div class="select is-fullwidth">
                            <select
                              v-model="reservation.tax_dispositif"
                              @change="$store.commit('modifyCurrentReservation', { key: 'tax_dispositif', value: reservation.tax_dispositif })"
                              :class="{'is-border' : reservation.destination !== 'invest' || !availableDispositifs}">
                              <option
                                :value="null"
                                selected>
                                Sélectionner
                              </option>
                              <template>
                                <option
                                  v-for="a in dispositifs"
                                  :key="a.value"
                                  :value="a.value">
                                  {{ a.label }}
                                </option>
                              </template>
                            </select>
                          </div>
                        </div>
                        <p
                          v-if="error.tax"
                          class="help is-danger">
                          Le champ est obligatoire
                        </p>
                      </div>
                    </div>
                    <div
                      v-if="!isSeller"
                      class="column is-4">
                      <div class="is-margin-bottom-xsmall">
                        <r-label
                          :label="'Mandat de gestion'"
                          :is-required="true"
                          :green-check="true"
                          :value="reservation.mandat_de_gestion"></r-label>
                      </div>
                      <div class="control">
                        <div class="select is-fullwidth">
                          <select
                            class=""
                            @change="$store.commit('modifyCurrentReservation', { key: 'mandat_de_gestion', value: reservation.mandat_de_gestion })"
                            v-model="reservation.mandat_de_gestion"
                            id="mandat_de_gestion">
                            <option :value="null">
                              NC
                            </option>
                            <option :value="true">
                              Oui
                            </option>
                            <option :value="false">
                              Non
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="reservation.destination === 'invest'"
                      class="column is-4">
                      <div class="is-margin-bottom-xsmall">
                        <r-label
                          :label="'Objectif de l\'achat'"
                          :red-check="true"
                          :value="reservation.purchase_purpose">
                        </r-label>
                      </div>
                      <div class="control">
                        <div class="select is-fullwidth">
                          <select
                            class=""
                            @change="$store.commit('modifyCurrentReservation', { key: 'purchase_purpose', value: reservation.purchase_purpose })"
                            v-model="reservation.purchase_purpose">
                            <option :value="null">
                              Sélectionner
                            </option>
                            <option
                              v-for="a in PurposePurchaseValueList"
                              :key="a.value"
                              :value="a.value">
                              {{ a.label }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="is-margin-bottom-xsmall">
                  <div
                    style="margin-bottom: 0"
                    class="columns is-gapless is-mobile has-background-white is-minH50p is-border">
                    <div class="column is-padding-left is-padding-right is-self-centered">
                      <span
                        style="font-weight: 400"
                        class="is-uppercase title is-6">Financement</span>
                    </div>
                  </div>
                  <div class="columns is-gapless is-marginless-bottom">
                    <div
                      class="column is-narrow is-flex is-padding-small"
                      :class="validFinancementPreResa ? 'has-background-success' : 'has-background-white--darken1 tooltip is-tooltip-right'"
                      :data-tooltip="'Financement incomplet'">
                      <span
                        class="icon has-text-white is-self-centered"
                        :class="validFinancementPreResa ? 'has-text-white' : 'has-text-danger'">
                        <i
                          :class="validFinancementPreResa? 'fa-check-circle' : 'fa-exclamation-circle'"
                          class="fas"></i>
                      </span>
                    </div>
                    <div class="column has-background-white is-border-left is-border-right is-border-bottom">
                      <div
                        class="columns is-12 is-gapless is-marginless is-padding-left-small is-padding-right-small is-vcentered is-minH50p"
                        :class="!not_using_loan ? 'has-background-light is-border-bottom ' : 'has-background-dark'">
                        <div class="column is-narrow">
                          <div class="is-padding-top-xsmall is-padding-bottom-xsmall">
                            <div>
                              <input
                                :disabled="isPending"
                                id="use_loan"
                                v-model="not_using_loan"
                                name="use_loan"
                                class="switch is-success is-rounded"
                                type="checkbox">
                              <label
                                for="use_loan"
                                style="font-size: 12.5px"
                                :class="!not_using_loan ? '' : 'has-text-white'"
                                class="is-uppercase">Le réservataire déclare ne pas recourir à un ou plusieurs prêt
                                bancaire</label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        style="flex-flow: row nowrap; gap: 20px"
                        class="is-padding-small is-flex">
                        <!-- Garanti prêt -->
                        <div class="is-column is-gapless is-space-between is-marginless is-centered">
                          <div
                            class="control is-narrow is-paddingless is-nowrap">
                            <input
                              class="switch is-success is-rounded"
                              id="use_caution"
                              type="checkbox"
                              name="use_caution"
                              @input="$store.commit('modifyCurrentReservation', { key: 'funding_data.use_caution', value: reservation.funding_data.use_caution })"
                              v-model="reservation.funding_data.use_caution">
                            <label
                              for="use_caution"
                              class="is-uppercase">
                              <span
                                class="is-size-6 is-margin-top-xxsmall">Garanti par une caution</span>
                            </label>
                          </div>
                        </div>
                        <div class="is-column is-gapless is-space-between is-marginless is-centered">
                          <div
                            class="control column is-narrow is-paddingless is-nowrap">
                            <input
                              class="switch is-success is-rounded"
                              id="use_hypotheque"
                              type="checkbox"
                              name="use_hypotheque"
                              @input="$store.commit('modifyCurrentReservation', { key: 'funding_data.use_hypotheque', value: reservation.funding_data.use_hypotheque })"
                              v-model="reservation.funding_data.use_hypotheque">
                            <label
                              for="use_hypotheque"
                              class="is-uppercase">
                              <span
                                class="is-size-6 is-margin-top-xxsmall">Garanti par une hypothèque</span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="!isPending && !not_using_loan"
                        class="is-padding-left is-padding-right is-padding-bottom">
                        <!-- <div class="columns">
                          <div class="column">
                            <div class="is-margin-bottom-xsmall">
                              <r-label
                                :label="'Prêt bancaire'"
                                :is-required="true"
                                :green-check="true"
                                :value="not_using_loan"></r-label>
                            </div>
                            <div class="control">
                              <div class="select is-fullwidth">
                                <select
                                  class=""
                                  :disabled="isPending"
                                  :class="{'is-border' : isPending}"
                                  v-model="not_using_loan"
                                  id="use_loan">
                                  <option :value="null">
                                    NC
                                  </option>
                                  <option :value="false">
                                    Le réservataire déclare recourir à un ou plusieurs prêt bancaire
                                  </option>
                                  <option :value="true">
                                    Le réservataire déclare ne pas recourir à un ou plusieurs prêt bancaire
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div> -->
                        <div class="columns is-multiline">
                          <div class="column is-12 is-6-fullhd">
                            <r-label
                              :label="'Nom de l\'organisme bancaire'"
                              :is-required="false"
                              :value="reservation.funding_data.initial_bank_name"></r-label>
                            <v-input
                              id="initial_bank_name"
                              name="initial_bank_name"
                              @input="val => $store.commit('modifyCurrentReservation', { key: 'funding_data.initial_bank_name', value: val })"
                              :model="reservation.funding_data.initial_bank_name"
                              data-vv-as="Organisme bancaire"
                              v-validate="'min:2'"
                              :errors-bag="errors"
                              data-vv-value-path="val">
                            </v-input>
                          </div>
                        </div>
                        <div class="columns is-multiline">
                          <div class="column is-4">
                            <r-label
                              :label="'MONTANT MAXIMUM À EMPRUNTER'"
                              :value="reservation.funding_data.initial_loan_value"
                              :red-check="true"></r-label>
                            <div class="field has-addons">
                              <div class="control">
                                <a class="button is-static is-border is-square">
                                  <span class="icon"><i class="fas fa-euro-sign"></i></span>
                                </a>
                              </div>
                              <div class="control is-expanded">
                                <v-input
                                  id="initial_loan_value"
                                  name="initial_loan_value"
                                  @input="val => $store.commit('modifyCurrentReservation', { key: 'funding_data.initial_loan_value', value: val })"
                                  :model="reservation.funding_data.initial_loan_value"
                                  class=""
                                  v-validate="'decimal:2'"
                                  :errors-bag="errors"
                                  data-vv-value-path="val"
                                  :number="true"
                                  :three-space="true"
                                  input-type="number"
                                  data-vv-as="Montant maximum à emprunter">
                                </v-input>
                              </div>
                            </div>
                          </div>
                          <div class="column is-4">
                            <r-label
                              :label="'MONTANT DE L\'APPORT'"
                              :value="reservation.funding_data.contribution_amount"
                              :red-check="true"></r-label>
                            <div class="field has-addons">
                              <div class="control">
                                <a class="button is-static is-border is-square">
                                  <span class="icon"><i class="fas fa-euro-sign"></i></span>
                                </a>
                              </div>
                              <div class="control is-expanded">
                                <v-input
                                  id="contribution_amount"
                                  name="contribution_amount"
                                  @input="val => $store.commit('modifyCurrentReservation', { key: 'funding_data.contribution_amount', value: val })"
                                  :model="reservation.funding_data.contribution_amount"
                                  class=""
                                  v-validate="'decimal:2'"
                                  :errors-bag="errors"
                                  data-vv-value-path="val"
                                  :number="true"
                                  :three-space="true"
                                  input-type="number"
                                  data-vv-as="Montant de l'apport">
                                </v-input>
                              </div>
                            </div>
                          </div>
                          <div class="column is-4">
                            <r-label
                              :label="'ORIGINE DE L\'APPORT'"
                              :value="reservation.funding_data.origin_contribution"
                              :red-check="true"></r-label>
                            <v-input
                              id="origin_contribution"
                              name="origin_contribution"
                              @input="val => $store.commit('modifyCurrentReservation', { key: 'funding_data.origin_contribution', value: val })"
                              :model="reservation.funding_data.origin_contribution"
                              data-vv-as="Origine de l'apport"
                              v-validate="'min:2'"
                              :errors-bag="errors"
                              data-vv-value-path="val">
                            </v-input>
                          </div>
                          <div class="column is-4">
                            <r-label
                              :label="'DURÉE max du prêt'"
                              :value="reservation.funding_data.initial_loan_duration"
                              :red-check="true"></r-label>
                            <div class="field has-addons">
                              <div class="control">
                                <a class="button is-static is-border is-square">
                                  <span class="icon"><i class="far fa-clock"></i></span>
                                </a>
                              </div>
                              <div class="control is-expanded">
                                <v-input
                                  id="initial_loan_duration"
                                  name="initial_loan_duration"
                                  @input="val => $store.commit('modifyCurrentReservation', { key: 'funding_data.initial_loan_duration', value: val })"
                                  :model="reservation.funding_data.initial_loan_duration"
                                  :placeholder="'en année'"
                                  data-vv-as="Durée max du prêt"
                                  v-validate="'min:1'"
                                  :errors-bag="errors"
                                  data-vv-value-path="val">
                                </v-input>
                              </div>
                            </div>
                          </div>
                          <div class="column is-4">
                            <r-label
                              :label="`taux d’interêt max`"
                              :red-check="true"
                              :value="reservation.funding_data.initial_loan_rate"></r-label>
                            <div class="field has-addons is-marginless-bottom">
                              <div class="control">
                                <a class="button is-square is-static is-border"><span class="icon"><i
                                  class="fas fa-percent"></i></span></a>
                              </div>
                              <div class="control is-expanded">
                                <input
                                  name="taux_com"
                                  v-model.number="reservation.funding_data.initial_loan_rate"
                                  max="100"
                                  @input="$store.commit('modifyCurrentReservation', { key: 'funding_data.initial_loan_rate', value: reservation.funding_data.initial_loan_rate })"
                                  class="input"
                                  :step="0.1"
                                  type="number"
                                  data-type-cy="input"
                                  data-value-cy="initial_loan_rate">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        v-else-if="isPending && not_using_loan === false"
                        class="is-border-top has-background-white is-padding">
                        <div class="columns is-multiline">
                          <span class="column is-6"><span class="label">Organisme bancaire : </span><span v-if="'initial_bank_name' in reservation.funding_data && reservation.funding_data.initial_bank_name">{{ reservation.funding_data.initial_bank_name }}</span><span v-else>NC</span></span>
                          <span class="column is-6"><span class="label">Montant maximum a emprunter : </span><span v-if="'initial_loan_value' in reservation.funding_data && reservation.funding_data.initial_loan_value">{{ reservation.funding_data.initial_loan_value }} €</span><span v-else>NC</span></span>
                          <span class="column is-6"><span class="label">Durée maximale du prêt : </span><span v-if="'initial_loan_duration' in reservation.funding_data && reservation.funding_data.initial_loan_duration">{{ reservation.funding_data.initial_loan_duration }} année(s)</span><span v-else>NC</span></span>
                          <span class="column is-6"><span class="label">Taux d’interêt maximum : </span><span v-if="'initial_loan_rate' in reservation.funding_data && reservation.funding_data.initial_loan_rate">{{ reservation.funding_data.initial_loan_rate }} %</span><span v-else>NC</span></span>
                          <span class="column is-6"><span class="label">Origine de l'apport : </span><span v-if="'origin_contribution' in reservation.funding_data && reservation.funding_data.origin_contribution">{{ reservation.funding_data.origin_contribution }}</span><span v-else>NC</span></span>
                          <span class="column is-6"><span class="label">Montant de l'apport : </span><span v-if="'contribution_amount' in reservation.funding_data && reservation.funding_data.contribution_amount">{{ reservation.funding_data.contribution_amount }}</span><span v-else>NC</span></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="is-padding-left-small is-padding-right-small is-flex is-minH50p is-border"
                  :class="!reservation.funding_data.security_deposit ? 'has-background-light ' : ' has-background-dark'">
                  <div class="is-self-centered is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right">
                    <div>
                      <input
                        id="security_deposit"
                        v-model="reservation.funding_data.security_deposit"
                        name="security_deposit"
                        class="switch is-success is-rounded"
                        type="checkbox">
                      <label
                        for="security_deposit"
                        :class="!reservation.funding_data.security_deposit ? '' : 'has-text-white'"
                        class="is-uppercase">Dépot de garantie déposé à la signature</label>
                    </div>
                  </div>
                </div>
                <div
                  v-if="reservation.funding_data.security_deposit"
                  class="notification is-border-bottom is-border-left is-border-right has-background-light is-multiline columns is-gapless is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall is-vcentered is-minH50p is-marginless-bottom">
                  <div class="column is-12 is-padding-bottom-small is-padding-left-xsmall">
                    <div class="">
                      <span class="is-uppercase is-size-7 has-text-weight-medium">Merci de préciser le montant du dépot de garantie déposé à la signature du contrat de réservation.</span>
                    </div>
                  </div>
                  <div class="column is-narrow is-4 is-padding-left-xsmall">
                    <div class="field has-addons">
                      <div class="control">
                        <a class="button is-static is-border is-square">
                          <span class="icon"><i class="fas fa-euro-sign"></i></span>
                        </a>
                      </div>
                      <div class="control is-expanded">
                        <v-input
                          id="security_deposit_value"
                          name="Dépot de garantie"
                          @input="val => setPercentageContribution(val)"
                          :model="reservation.funding_data.security_deposit_value"
                          class=""
                          v-validate="'decimal:2'"
                          :errors-bag="errors"
                          data-vv-value-path="val"
                          :number="true"
                          :three-space="true"
                          input-type="number"
                          data-vv-as="">
                        </v-input>
                      </div>
                    </div>
                  </div>
                  <div class="column is-narrow is-4 is-padding-left-large">
                    <div class="field has-addons">
                      <div class="control is-expanded">
                        <v-input
                          id="percentage_contribution"
                          name="Pourcentage de contribution"
                          @input="val => setSecurityDepositValue(val)"
                          :model="reservation.funding_data.percentage_contribution"
                          class=""
                          v-validate="'decimal:2'"
                          :errors-bag="errors"
                          data-vv-value-path="val"
                          :number="true"
                          input-type="number"
                          data-vv-as="">
                        </v-input>
                      </div>
                      <div class="control">
                        <a class="button is-static is-border is-square">
                          <i class="fas fa-percentage"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="column is-narrow is-4 is-padding-left-large">
                    <div class="select is-fullwidth">
                      <select
                        v-model="reservation.funding_data.security_deposit_type">
                        <option
                          :value="null"
                          disabled
                          selected>
                          Selectionnez
                        </option>
                        <option
                          v-for="s in securityDepositeTypeList"
                          :value="s.value"
                          :key="s.value">
                          {{ s.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <!-- Mention particulière -->
                <div
                  class="is-padding-left-small is-padding-right-small is-flex is-minH50p is-border is-margin-top-xsmall"
                  :class="openMentionPart ? 'has-background-light' : ' has-background-dark'">
                  <div class="is-self-centered is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right">
                    <div>
                      <input
                        id="reservation.mention_comment"
                        v-model="openMentionPart"
                        name="security_deposit"
                        class="switch is-success is-rounded"
                        type="checkbox">
                      <label
                        for="reservation.mention_comment"
                        :class="openMentionPart ? '' : 'has-text-white'"
                        class="is-uppercase">Ajouter Mention particulière</label>
                    </div>
                  </div>
                </div>
                <div
                  v-if="openMentionPart"
                  class="has-background-white is-border-left is-border-right is-border-bottom is-margin-bottom-xsmall">
                  <template v-if="openComment">
                    <div
                      v-if="!openWysiMention"
                      @click="openWysiwyg(true)"
                      class="vadDiscussion"
                      style="cursor: pointer;">
                      <div
                        class="vadDiscussion--bulle is-size-6 is-minH50p vadDiscussion--bulle--has-actions is-cut is-padding-left">
                        <div
                          class="content"
                          v-if="isAdmin && reservation.mention_comment"
                          v-html="reservation.mention_comment"></div>
                        <div class="actionsOnRow actionsOnRow--vertical">
                          <div class="">
                            <button
                              @click="openWysiwyg(true)"
                              class="is-min-height-full">
                              <span class="icon is-small"><i class="fal fa-edit"></i></span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-else
                      class="columns is-gapless">
                      <div class="column">
                        <wysiwyg-editor
                          :light="true"
                          :tooltip-top="true"
                          :model="reservation.mention_comment"
                          @change="val => $store.commit('modifyCurrentReservation', { key: 'mention_comment', value: val })"
                          class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
                        </wysiwyg-editor>
                      </div>
                      <div class="actionsOnRow actionsOnRow--vertical">
                        <div>
                          <!-- <button @click="openWysi = false" -->
                          <button
                            @click="openWysiMention = !reservation.mention_comment; baseMentionComment = reservation.mention_comment"
                            type="button"
                            class="button"
                            :class="[(baseMentionComment !== reservation.mention_comment) ? 'is-success' : 'is-info']"
                            :disabled="(baseMentionComment === reservation.mention_comment)">
                            <span class="icon is-small">
                              <i class="fal fa-save"></i>
                            </span>
                          </button>
                        </div>
                        <div class="">
                          <button
                            :disabled="!baseMentionComment"
                            type="button"
                            :class="{'actionsOnRow-btn--hoverIsDanger': reservation.mention_comment}"
                            @click="reservation.mention_comment?openWysiMention = false:null; reservation.mention_comment = baseMentionComment">
                            <span class="icon is-small"><i class="fal fa-times"></i></span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
                <!-- Commentaire -->
                <div>
                  <div
                    class="is-padding has-background-light is-border"
                    id="commentary-preresa"
                    v-if="(isEditing || isRefused)">
                    <div
                      v-if="!reservation.comment"
                      class="is-margin-bottom-xsmall">
                      <span class="is-uppercase title is-6">Ajouter un commentaire : </span>
                    </div>
                    <div
                      v-else
                      class="is-margin-bottom-xsmall">
                      <span class="is-uppercase title is-6">Commentaires&nbsp;</span><span class="is-italic is-size-6 has-text-weight-light">(Visible que par les membres de votre organisation - Administrateur)</span>
                    </div>
                    <template v-if="openComment">
                      <div
                        v-if="!openWysi && reservation.comment"
                        @click="openWysiwyg()"
                        class="vadDiscussion is-border"
                        style="cursor: pointer;">
                        <div
                          class="vadDiscussion--bulle is-size-6 is-minH50p vadDiscussion--bulle--has-actions is-cut is-padding-left">
                          <div
                            class="content"
                            v-if="isAdmin && reservation.comment"
                            v-html="reservation.comment"></div>
                          <div class="actionsOnRow actionsOnRow--vertical">
                            <div class="">
                              <button
                                @click="openWysiwyg()"
                                class="is-min-height-full">
                                <span class="icon is-small"><i class="fal fa-edit"></i></span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        v-else
                        class="is-border-top columns is-gapless">
                        <div class="column">
                          <wysiwyg-editor
                            :light="true"
                            :tooltip-top="true"
                            :model="reservation.comment"
                            @change="val => $store.commit('modifyCurrentReservation', { key: 'comment', value: val })"
                            class="has-background-white editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
                          </wysiwyg-editor>
                        </div>
                        <div class="actionsOnRow actionsOnRow--vertical">
                          <div>
                            <!-- <button @click="openWysi = false" -->
                            <button
                              @click="openWysi = !reservation.comment; baseComment = reservation.comment"
                              type="button"
                              class="button"
                              :class="[(baseComment !== reservation.comment) ? 'is-success' : 'is-info']"
                              :disabled="(baseComment === reservation.comment)">
                              <span class="icon is-small">
                                <i class="fal fa-save"></i>
                              </span>
                            </button>
                          </div>
                          <div class="">
                            <button
                              :disabled="!baseComment"
                              type="button"
                              :class="{'actionsOnRow-btn--hoverIsDanger': reservation.comment}"
                              @click="reservation.comment?openWysi = false:null; reservation.comment = baseComment">
                              <span class="icon is-small"><i class="fal fa-times"></i></span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                  <div v-else-if="isPending && reservation.comment">
                    <div class="is-padding-left has-background-white is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall is-minH50p is-flex is-border-top">
                      <div class="is-self-centered">
                        <span class="is-uppercase title is-6">Commentaire</span>
                      </div>
                    </div>
                    <div class="is-padding">
                      <div
                        v-html="reservation.comment"
                        class="notification-content"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-12 is-5-widescreen is-5-fullhd is-paddingless-bottom">
              <div
                v-if="lot.sale_price_ttc !== reservation.sale_price_ttc"
                :style="'background-color: #FFE2E2'"
                class="column has-text-primary is-size-7 is-padding-xsmall info-profil is-margin-bottom-xxsmall">
                <div
                  style="min-width: auto; "
                  class="is-flex is-nowrap">
                  <span class="has-text-black has-text-weight-bold">ATTENTION LE PRIX DU LOT A CHANGÉ : {{ lot.sale_price_ttc }} €</span>
                </div>
              </div>
              <div class="has-backgroundg-white is-border-left is-margin-bottom-small is-border-right">
                <div
                  v-if="lot.nature !== 'parking' && (!isPending || (isAdmin && isPromoteur))"
                  class="is-border-top is-padding has-background-reserved">
                  <div class="columns is-gapless">
                    <div class="column is-12">
                      <div class="control">
                        <div class="select is-fullwidth">
                          <select v-model="selectedPack">
                            <option :value="null">
                              Prix immo TTC <span v-if="reservation.sale_price_ttc">- {{ reservation.sale_price_ttc }} €</span>
                            </option>
                            <option
                              class="is-uppercase"
                              v-for="(pack, idx) in packList"
                              :value="pack"
                              :key="pack.name + '-' + idx">
                              {{ pack.name }} TTC <span v-if="pack.sale_price_ttc">- {{ pack.sale_price_ttc.toFixed(2) }} €</span>
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="selectedPack && selectedPack.description"
                    class="has-text-black-ter">
                    <b
                      class="is-size-6"
                      v-html="selectedPack.description"></b>
                  </div>
                </div>
                <div
                  v-if="selectedPack === null"
                  class="has-background-reserved is-padding is-border-top">
                  <div class="columns is-variable is-2">
                    <div class="column">
                      <r-label
                        :label="'Prix immo du lot HT'"
                        :red-check="true"
                        :value="reservation.sale_price_ht"
                        class="has-text-white"></r-label>
                      <div class="field has-addons">
                        <p class="control is-expanded">
                          <v-input
                            id="sale_price_ht"
                            :name="'sale_price_ht'"
                            @input="val => updateSalePriceHt(val)"
                            :model="reservation.sale_price_ht"
                            :number="true"
                            :disabled="!(isPromoteur && isAdmin)"
                            input-type="number"
                            :errors-bag="errors"
                            data-vv-value-path="val"
                            :classes-input="[!(isPromoteur && isAdmin) ? 'has-text-dark' : '']"
                            data-vv-as=" "
                            v-validate="'required|decimal:2'">
                          </v-input>
                        </p>
                        <div class="control">
                          <a class="button is-static is-border is-square"><b class="">€&nbsp;HT</b></a>
                        </div>
                      </div>
                    </div>
                    <div class="column is-narrow">
                      <div class="field">
                        <r-label
                          :red-check="false"
                          :label="'Tva'"
                          :value="reservation.tva"
                          :truncate="false"
                          class="has-text-white"></r-label>
                        <div class="control">
                          <div class="select">
                            <select
                              class="has-text-weight-medium"
                              v-model="reservation.tva"
                              @change="updateTva(reservation.tva, reservation.sale_price_ttc, null)">
                              <option
                                v-for="(tvaVal, idx) in tvaList"
                                :value="tvaVal"
                                :key="tvaVal + '-' + idx">
                                <span v-if="tvaVal !== 'autre'">{{ tvaVal | tvaLabelRounded }}%</span>
                                <span v-else>autre</span>
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div
                        class="has-text-weight-light has-text-white is-size-6"
                        v-if="tvaAmount">
                        ({{ tvaAmount | prettyPrice }} €)
                      </div>
                    </div>
                    <div class="column">
                      <r-label
                        :label="'Prix immo TTC'"
                        :red-check="true"
                        :value="reservation.sale_price_ttc"
                        class="has-text-white"></r-label>
                      <div class="field has-addons">
                        <p class="control is-expanded">
                          <v-input
                            id="sale_price"
                            :name="'sale_price'"
                            input-type="number"
                            @input="val => updateSalePrice(val)"
                            :disabled="!(isPromoteur && isAdmin)"
                            :model="reservation.sale_price_ttc"
                            :errors-bag="errors"
                            data-vv-value-path="val"
                            :classes-input="[!(isPromoteur && isAdmin) ? 'has-text-dark' : '']"
                            data-vv-as=" "
                            v-validate="'required|decimal:2'">
                          </v-input>
                        </p>
                        <div class="control">
                          <a class="button is-static is-border is-square"><b class="">€&nbsp;TTC</b></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="parkings && parkings.length"
                  class="is-padding-left-small is-padding-right is-padding-top-xsmall has-background-white is-padding-bottom-xsmall is-minH50p is-flex is-border-top">
                  <div class="is-self-centered">
                    <span class="is-uppercase title is-6">Dont prix {{ parkings.length > 1 ? 'des stationnements' : 'du stationnement' }}</span>
                  </div>
                </div>
                <template>
                  <div
                    v-for="(parking, idx) in parkings"
                    :key="idx"
                    class="is-border-top has-background-white is-padding-left is-padding-right ">
                    <div class="columns is-gapless is-vcentered is-minH50p">
                      <div class="column is-padding-right">
                        <span>
                          <b class="is-size-6">{{ parking.nature | lotTypeLabel }} :</b>&nbsp;
                          <span
                            class="is-size-6"
                            v-for="(type, i ) in parking.parking_type"
                            :key="'type' + i">{{ i > 0 ? ', ' : '' }}{{ type | lotSubtypeLabel }}</span>&nbsp;
                          <span
                            class="is-size-6"
                            v-if="parking.info">({{ parking.info }})</span>&nbsp;
                          <span
                            class="is-size-6"
                            v-for="(sale_mode, i ) in parking.sales_mode"
                            :key="'sale_mode' + i">{{ i > 0 ? ', ' : '' }}{{ sale_mode | salesmodeLabel }}</span>
                          <span v-if="parking.sale_price_ttc"> - {{ parking.sale_price_ttc }} €</span>
                        </span>
                      </div>
                      <div class="column is-narrow">
                        <div class="field">
                          <input
                            type="checkbox"
                            :id="'check_parking' + idx"
                            :value="'check_parking' + idx"
                            v-model="checkParking[parking.pk]"
                            @change="initParking"
                            class="switch is-rounded is-success">
                          <label :for="'check_parking' + idx">&nbsp;</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
              <div
                v-if="(!program.is_valid || !lot.is_valid)"
                class="is-flex is-minH50p has-background-warning is-padding-left-small is-padding-right-small is-padding-top-xxsmall is-padding-bottom-xxsmall is-border-top is-margin-bottom-xsmall">
                <div class="is-self-centered is-size-7">
                  <span class="icon has-text-danger is-margin-right-xxsmall is-size-5"><i class="fas fa-exclamation-triangle"></i></span>
                  <span class="has-text-primary is-uppercase">Les informations programmes et lot sont nécessaires pour l'édition automatique du contrat de réservation. Cela ne bloque pas la validation du passage en réservation.</span>
                </div>
              </div>
              <div style="position: sticky; top: 65px">
                <div
                  v-if="((canEdit && (isOptionUser || isAdminUser || isManagerUser || isContactSharedByPromoteur)) || ((isPending || isOptionUser || isAdminUser || isContactSharedByPromoteur) && isPromoteur && isAdmin)) && !loadSubmitAsk && !loadSubmitValidation && !loadSubmitRefuse"
                  class="has-text-centered is-flex is-minH50p">
                  <button
                    v-if="reservation.status !== 'pending' || (currentUser.pk === seller.pk)"
                    @click="submitReservation"
                    :style="pendingReservationSubmit ? 'background-color: #5BB4EB' : 'background-image: linear-gradient(to top, #70ab64, #70ab64 99%, #95d288)'"
                    style="border: none; color: white; height: 60px; border-radius: 4px; margin-bottom: 10px"
                    class="has-text-centered column is-12 has-cursor-pointer">
                    <span class="is-uppercase is-size-6 ">{{ pendingReservationSubmit ? 'Enregistrer modification' : 'Valider votre demande' }}</span>
                  </button>
                  <div
                    v-else
                    class="has-text-centered is-flex-center is-minH50p"
                    style="width: 100%">
                    <button
                      v-if="pendingReservationSubmit"
                      @click="putReservation()"
                      style="border: none; color: white; height: 60px; border-radius: 4px; margin-bottom: 10px; background-color: #5BB4EB"
                      class="has-text-centered column is-12 has-cursor-pointer">
                      <span class="is-uppercase is-size-6 ">Enregistrer modification</span>
                    </button>
                    <div
                      class="is-flex"
                      style="width: 100%; gap: 10px"
                      v-else>
                      <button
                        @click="refuseValidation()"
                        class="has-text-centered has-cursor-pointer is-padding-small"
                        style="border: none; color: white; border-radius: 4px; background-color: #24323b; width: 50%; height: 65px">
                        <span class="is-uppercase is-size-6 has-text-weight-medium">Refuser</span>
                      </button>
                      <button
                        @click="approveValidation()"
                        class="has-text-centered has-cursor-pointer is-padding-small"
                        style="border: none; color: white; border-radius: 4px; background-image: linear-gradient(to top, #70ab64, #70ab64 99%, #95d288); width: 50%; height: 65px">
                        <span class="is-uppercase is-size-6 has-text-weight-medium">Accepter</span>
                      </button>
                    </div>
                  </div>
                </div>
                <!-- <submit-sticky-buttons
                  v-if="((canEdit && (isOptionUser || isAdminUser || isManagerUser || isContactSharedByPromoteur)) || ((isPending || isOptionUser || isAdminUser || isContactSharedByPromoteur) && isPromoteur && isAdmin)) && !loadSubmitAsk && !loadSubmitValidation && !loadSubmitRefuse"
                  @submit="submitReservation"
                  :cancel="cancelButton"
                  :cancel-text="cancelText"
                  :has-cancel="hasCancel"
                  :cancel-class="cancelClass"
                  :submit-class="submitClass"
                  :global-class="'is-fullwidth is-paddingless-top is-paddingless-bottom'"
                  button-id="PreReservation"
                  :loading="submitLoading"
                  :submit-text="submitText">
                </submit-sticky-buttons> -->
              </div>
            </div>
          </div>
        </page-content>
      </div>
    </div>
    <!-- VUE VENDEUR -->
    <div v-else>
      <spinner-round
        :is-loading="loading || forceLoading"
        v-if="loading || forceLoading"></spinner-round>
      <div v-if="reservation && lot && program && !loading">
        <page-nav-bar
          :is-sticky="true"
          :back-button="true"
          :has-actions="false"
          :no-margin-bottom="true"
          :hide-separators="true">
          <h1 slot="title">
            <span>Demande de passage en pré-réservation</span>
            <span class="has-text-weight-bold">
              <router-link
                class="is-paddingless"
                :to="{'name': 'LotVue', params: {id: lot.pk}}"
                v-if="lot && lot.pk">
                - Lot {{ lot.ref }}
              </router-link>
            </span>
          </h1>
          <router-link
            slot="subtitle"
            :to="{'name': 'ProgramVue', params: {id: program.pk}}"
            v-if="program && program.pk">
            / {{ program.name }}
          </router-link>
          <span
            slot="label"
            v-if="isDistributeur">- {{ program.promoteur.name }}</span>
        </page-nav-bar>
        <page-content
          style="padding-top: 4.5rem"
          :has-no-padd-on-act-on-desktop="false">
          <div class="columns is-variable is-2 is-multiline">
            <div class="column is-12 is-8-widescreen is-8-fullhd is-paddingless-bottom">
              <chronological-pre-resa
                v-if="!isPending"
                :current-step="currentStep"
                @update:currentStep="currentStep = $event"></chronological-pre-resa>
              <donnee-pre-resa
                v-if="currentStep === 1 && !isPending"
                :reservation="reservation"
                :adv-destinations-list="advDestinationsList"
                :error="error"
                :dispositifs="dispositifs"
                :available-dispositifs="availableDispositifs"
                :buyers="buyers"
                :delete-document="deleteDocument"
                :open-buyer-selection="openBuyerSelection"
                :open-modal-contact-pre-resa-info="openModalContactPreResaInfo">
              </donnee-pre-resa>
              <price-pre-resa
                v-if="currentStep === 2 && !isPending"
                :selected-pack="selectedPack"
                :lot="lot"
                :pack-list="packList"
                :reservation="reservation"
                :parkings="parkings"
                :check-parking="checkParking"
                :tva-list="tvaList"
                @update-tva="updateTva"
                @update:selectedPack="selectedPack = $event"
                @update:checkParking="updateCheckParking"></price-pre-resa>
              <financement-pre-resa
                v-if="currentStep === 3 && !isPending"
                :reservation="reservation"
                :not_using_loan="not_using_loan"
                @update:notUsingLoan="notUsingLoanUpdate"
                @update:setSecurityDepositValue="setSecurityDepositValue"
                @update:setPercentageContribution="setPercentageContribution"></financement-pre-resa>
              <validation-pre-resa
                v-if="currentStep === 4 || isPending"
                :buyers="buyers"
                :not_using_loan="not_using_loan"
                :reservation="reservation"
                :selected-pack="selectedPack"
                :check-parking="checkParking"
                :parkings="parkings"
                :current-step="currentStep"
                @update:currentStep="currentStep = $event">
              </validation-pre-resa>
            </div>
            <div
              v-if="canEdit && !isPending"
              class="has-text-centered column is-12 is-4-widescreen is-4-fullhd is-paddingless-bottom">
              <div style="position: sticky; top: 95px">
                <button
                  @click="currentStep === 4 ? (!program.pre_reserved_auto? askValidation() : approveValidation()) : nextStep()"
                  :style="checkForNext ? '' : 'opacity: 0.5; cursor: not-allowed'"
                  style="background-image: linear-gradient(to top, #70ab64, #70ab64 99%, #95d288); border: none; color: white; height: 120px; border-radius: 4px; margin-bottom: 10px"
                  class="has-text-centered column is-12 has-cursor-pointer">
                  <span class="is-uppercase is-size-6 ">{{ currentStep === 4 ? 'Valider votre demande' : 'étape suivante' }}</span>
                </button>
                <button
                  @click="cancelReservation()"
                  style="border: none; color: #5c5c5c; height: 50px; border-radius: 4px; margin-bottom: 10px"
                  class="has-text-centered has-background-light column is-12 is-border has-cursor-pointer">
                  <span class="is-uppercase is-size-6 ">Annuler</span>
                </button>
                <a
                  v-if="currentStep !== 1"
                  @click="previousStep()"
                  style="color: #5c5c5c"
                  class="column is-12 is-uppercase is-underline is-size-6">Retour étape précédente</a>
              </div>
              <!-- <submit-sticky-buttons
                v-if="((canEdit && (isOptionUser || isAdminUser || isManagerUser || isContactSharedByPromoteur)) || ((isPending || isOptionUser || isAdminUser || isContactSharedByPromoteur) && isPromoteur && isAdmin)) && !loadSubmitAsk && !loadSubmitValidation && !loadSubmitRefuse"
                @submit="submitReservation"
                :cancel="cancelButton"
                :cancel-text="cancelText"
                :has-cancel="hasCancel"
                :cancel-class="cancelClass"
                :submit-class="submitClass"
                :global-class="'is-paddingless-top is-paddingless-bottom'"
                button-id="PreReservation"
                :loading="submitLoading"
                :submit-text="submitText"></submit-sticky-buttons> -->
            </div>
            <div
              v-else
              class="column is-12 is-4-widescreen is-4-fullhd is-paddingless-bottom">
              <div
                style="background-color:#E3ECE8; border: none;"
                class="is-flex is-align-items-center column is-12 has-cursor-pointer is-padding">
                <div
                  class="is-flex-center is-margin-right"
                  style="background-color: #80BB73; color: white; min-width: 37px; height: 37px; z-index: 1; border-radius: 20px">
                  <i class="is-size-1 fas fa-check-circle"></i>
                </div>
                <span class="is-size-6 has-text-weight-bold is-margin-right">
                  Félicitation, votre demande de réservation a été transmise au promoteur : {{ lot.promoteur.name }}.
                  <br>
                  Votre demande va être controlée pour validation.
                  Vous serez notifié dès validation de votre demande.
                </span>
              </div>
              <a
                @click="openModalTicket()"
                style="gap: 5px"
                class="has-cursor-pointer has-background-light is-border is-flex-center is-space-between is-nowrap has-text-primary is-size-7 is-padding">
                <div class="is-flex-center">
                  <i class="is-size-2 far fa-comment-alt is-margin-right"></i>
                  <span class="is-size-6 has-text-weight-light is-uppercase ">Contacter le promoteur</span>
                </div>
                <i class="fas fa-arrow-right"></i>
              </a>
            </div>
          </div>
        </page-content>
      </div>
    </div>
  </div>
</template>

<script>
import { bus, EVENTS } from '@/bus'
import moment from 'moment'
import { DefaultValues, Quickview } from '@/mixins'
import { mapState, mapGetters } from 'vuex'
import { debounce, isObject } from 'lodash'
import TiersLink from '@/components/tiers/TiersLinkMixin'

export default {
  name: 'PreReservation',
  components: {
    TiersSelector: () => import('@/components/tiers/TiersSelector'),
    FinancementPreResa: () => import('./PreResaComposant/FinancementPreResa.vue'),
    PricePreResa: () => import('./PreResaComposant/PricePreResa.vue'),
    DonneePreResa: () => import('./PreResaComposant/DonneePreResa.vue'),
    ChronologicalPreResa: () => import('./PreResaComposant/ChronologicalPreResa.vue'),
    AdvLotCompact: () => import('./AdvLotCompact'),
    ValidationPreResa: () => import('./PreResaComposant/ValidationPreResa.vue'),
    MembrePreResa: () => import('./MembrePreResa')
  },
  filters: {
    tvaLabelRounded (value) {
      if (value.toString().split('.').length === 1) {
        return `${value}.0`
      } else {
        return value
      }
    }
  },
  mixins: [DefaultValues, Quickview, TiersLink],
  data () {
    return {
      selectedNotaireClient: null,
      companyAddress: null,
      forceLoading: false,
      fromStart: true,
      fromPackReselection: false, // prevent reservation update hanging
      tvaList: [20, 10, 7, 5.5, 0, 'autre'],
      initialTva: null,
      loadSubmitAsk: false,
      loadSubmitValidation: false,
      loadSubmitRefuse: false,
      tvaAmount: null,
      not_using_loan: false,
      checkParking: {},
      packList: [],
      selectedPack: null,
      error: {
        destination: false,
        tax: false
      },
      pendingRemuneration: null,
      submitLoading: false,
      loading: true,
      buyers: [],
      reservation: null,
      option: null,
      seller: null,
      signature_date: null,
      sale_date: null,
      lot: null,
      program: null,
      displayToolbar: false,
      parkings: [],
      openComment: true,
      openWysi: true,
      openWysiMention: false,
      baseComment: null,
      useCaution: false,
      use_hypotheque: false,
      getTva: null,
      baseMentionComment: false,
      duplicateContact: false,
      duplicateDenunciation: false,
      dispositifs_list: [],
      invest: false,
      main_residence: false,
      updated_on: null,
      currentStep: 1,
      openMentionPart: false,
      fromSellerRemu: true
    }
  },
  beforeRouteLeave (to, from, next) {
    if ((to.name === 'ContactEdit' || to.name === 'LotEdit' || to.name === 'ParkingEdit' || to.name === 'ProgramEdit') && this.pendingReservationSubmit) {
      return this.$swal({
        title: 'Souhaitez vous vraiment quitter ce passage en pré-réservation ?',
        text: 'Si vous quittez sans les enregistrer elles ne seront pas enregistrées.',
        confirmButtonText: 'Enregistrer et quitter',
        confirmButtonColor: '#81bc74',
        cancelButtonText: 'Quiter sans enregistrer',
        cancelButtonColor: '#ff0200',
        showCloseButton: true
      }).then(r => {
        if (r.value) {
          this.submitReservation()
          next()
        } else if (r.dismiss === 'cancel') {
          this.$store.commit('setReservationSubmitButtons', false)
          next()
        }
      })
    } else {
      this.$store.commit('setReservationSubmitButtons', false)
      next()
    }
  },
  computed: {
    ...mapState(['quickview', 'modal', 'currentUser', 'currentReservation', 'pendingReservationSubmit']),
    ...mapGetters(['isAdmin', 'isManager', 'isPromoteur', 'canUseElectronicSign', 'isDistributeur']),
    /**
       * reservation status is pending
       * @returns {boolean}
       */
    isPending () {
      return this.reservation.status === 'pending'
    },
    tva () {
      return Number(this.reservation.sale_price_ttc - this.reservation.sale_price_ht).toFixed(2)
    },
    amountTva () {
      return Number((this.reservation.sale_price_ttc - this.reservation.sale_price_ht) / this.reservation.sale_price_ht * 100)
    },
    /**
      * reservation status is editing
      * @returns {boolean}
      */
    isEditing () {
      return this.reservation.status === 'editing'
    },
    /**
      * reservation status is refused
      * @returns {boolean}
      */
    isRefused () {
      return this.reservation.status === 'refused'
    },
    /**
      * reservation status is pre_reserved
      * @returns {boolean}
      */
    isPreReserved () {
      return this.reservation.status === 'pre_reserved'
    },
    /**
      * can add buyers if less than 3
      * @returns {boolean}
      */
    canAdd () {
      return this.buyers.length <= 2
    },
    /**
      * reservation pk
      * @returns {string}
      */
    reservationPk () {
      return this.$route.params.id
    },
    /**
      * available dispositifs
      * @returns {array}
      */
    availableDispositifs () {
      return this.taxDispositifsList
    },
    filteredTypesTaxList () {
      return this.typesTaxList.filter((x) => x.show.includes('adv'))
    },
    /**
      * reservation is complete
      * @returns {boolean}
      */
    isComplete () {
      return this.reservation.is_complete
    },
    /**
      * reservation is valid
      * @returns {boolean}
      */
    isValid () {
      return this.reservation.is_valid
    },
    /**
      * current user is option user
      * @returns {boolean}
      */
    isOptionUser () {
      return this.currentUser.pk === this.reservation.user.pk
    },
    /**
      * current user is same account user and is admin
      * @returns {boolean}
      */
    isAdminUser () {
      return (this.currentUser.account.pk === this.reservation.account.pk && this.isAdmin)
    },
    /**
      * current user is admin, user is promoteur, user as same account as the contact (it means that contact is shared)
      * @returns {boolean}
      */
    isContactSharedByPromoteur () {
      return (this.currentUser.account.pk !== this.reservation.account.pk && this.reservation.contact.account.pk === this.currentUser.account.pk && this.isAdmin && this.isPromoteur)
    },
    /**
      * current user is save account user and is manager
      * @returns {boolean}
      */
    isManagerUser () {
      return (this.currentUser.account.pk === this.reservation.account.pk && this.isManager)
    },
    isCaution () {
      return this.reservation.funding_data.useCaution
    },
    isHypotheque () {
      return this.reservation.funding_data.use_hypotheque
    },
    /**
      * can edit
      * @returns {boolean}
      */
    canEdit () {
      return ['editing', 'refused'].includes(this.reservation.status)
    },
    /**
      * has action button
      * @returns {boolean}
      */
    hasActionButton () {
      return (this.reservation.status === 'editing' && this.isOptionUser && this.isComplete) ||
          (this.reservation.status === 'pending' && this.reservation.use_custom_contract && this.reservation.custom_contract && this.isComplete) ||
          (this.reservation.status === 'pending' && !this.reservation.use_custom_contract && this.isComplete) ||
          !(this.isAdmin && this.isPromoteur)
    },
    /**
      * is promoteur of the reservation
      * @returns {boolean}
      */
    isPromoteurAdmin () {
      return this.reservation.promoteur.pk === this.currentUser.account.pk && this.isPromoteur && this.isAdmin
    },
    /**
      * can ask validation
      * @returns {boolean}
      */
    canAskValidation () {
      return ['editing', 'refused'].includes(this.reservation.status)
    },
    /**
      * remuneration is updated
      * @returns {boolean}
      */
    remunerationUpdated () {
      return this.pendingRemuneration !== this.reservation.remuneration
    },
    validNotary () {
      if (this.reservation.notary_details.use_buyer_notary) {
        return this.reservation.notary_details.name !== null && this.reservation.notary_details.name !== '' && this.reservation.notary_details.phone !== null && this.reservation.notary_details.phone !== '' && this.reservation.notary_details.email !== null && this.reservation.notary_details.email !== '' && this.reservation.notary_details.address !== null && this.reservation.notary_details.address !== ''
      } else {
        return true
      }
    },
    /**
      * financement is valid
      * @returns {boolean}
      */
    validFinancement () {
      if (this.reservation.funding_data.use_loan === false || this.reservation.funding_data.use_loan === null) {
        if (this.reservation.funding_data.security_deposit) {
          return this.reservation.funding_data.security_deposit_value !== null && this.reservation.funding_data.security_deposit_value !== '' && this.reservation.funding_data.security_deposit_value > 0
        } else {
          return true
        }
      } else {
        if (this.reservation.funding_data.security_deposit) {
          return this.reservation.funding_data.initial_loan_value !== null && this.reservation.funding_data.initial_loan_value !== '' &&
              this.reservation.funding_data.security_deposit_value !== null && this.reservation.funding_data.security_deposit_value !== '' &&
              this.reservation.funding_data.security_deposit_value > 0
        } else {
          return this.reservation.funding_data.initial_loan_value !== null && this.reservation.funding_data.initial_loan_value !== ''
        }
      }
    },
    validFinancementPreResa () {
      if (this.not_using_loan) {
        return true
      } else {
        if (this.reservation.funding_data.initial_loan_value && (this.reservation.funding_data.contribution_amount === 0 || this.reservation.funding_data.contribution_amount) && this.reservation.funding_data.origin_contribution && this.reservation.funding_data.initial_loan_duration && this.reservation.funding_data.initial_loan_rate) {
          return true
        } else {
          return false
        }
      }
    },
    /**
      * buyer is valid
      * @returns {boolean}
      */
    validBuyers () {
      let result = this.reservation.buyers.filter(x => {
        return x.is_complete === false
      })
      if (result.length >= 1) {
        return false
      } else {
        return true
      }
    },
    /**
      * submit text
      * @returns {string}
      */
    submitText () {
      if (this.pendingReservationSubmit) {
        return 'Enregistrer modification'
      } else if (!(this.isAdmin && this.isPromoteur) && !this.pendingReservationSubmit && !this.program.pre_reserved_auto) {
        return 'Valider votre demande de réservation'
      } else if (this.isAdmin && this.isPromoteur && !this.pendingReservationSubmit && this.isPending) {
        return 'Accepter réservation'
      } else {
        return 'Valider réservation'
      }
    },
    /**
      * cancel text
      * @returns {string}
      */
    cancelText () {
      if (!(this.isAdmin && this.isPromoteur) && this.pendingReservationSubmit) {
        return 'Annuler procédure'
      } else {
        return 'Refuser cette demande'
      }
    },
    /**
      * has cancel button
      * @returns {boolean}
      */
    hasCancel () {
      if ((!(this.isAdmin && this.isPromoteur) && this.pendingReservationSubmit) || (this.isAdmin && this.isPromoteur && !this.pendingReservationSubmit && (!this.isOptionUser || this.isContactSharedByPromoteur) && this.isPending)) {
        return true
      } else {
        return false
      }
    },
    /**
      * cancel class
      * @returns {string}
      */
    cancelClass () {
      if (!(this.isAdmin && this.isPromoteur) && this.pendingReservationSubmit) {
        return 'is-light'
      }
      if (!this.pendingReservationSubmit && this.isPending) {
        return 'is-danger'
      } else {
        return 'is-light'
      }
    },
    /**
      * submit class
      * @returns {string}
      */
    submitClass () {
      if (this.pendingReservationSubmit) {
        return 'is-success'
      } else {
        return 'is-pre_reserved'
      }
    },
    contractName () {
      if (this.reservation.contract_in_use != null) {
        let name = null
        for (let contract of this.program.contracts) {
          if (contract.pk === this.reservation.contract_in_use) {
            name = contract.name
          }
        }
        return name
      } else {
        return 'Contrat de Vadimm par défaut'
      }
    },
    dispositifs () {
      let dispositifs
      if (this.reservation.destination === 'invest') {
        if (this.isAdmin && this.isPromoteur) {
          dispositifs = this.typesTaxList.filter((x) => x.show.includes('adv'))
        } else {
          let lotDispositifs = this.reservation.lot.tax_dispositifs.filter(t => t !== 'prix_maitrise')
          dispositifs = this.typesTaxList.filter(dispositif => lotDispositifs.includes(dispositif.value))
        }
      }
      if (this.reservation.destination === 'main_residence') {
        if (this.isAdmin && this.isPromoteur) {
          dispositifs = this.dispositifsChoicesRpList
        } else {
          let lotDispositifs = this.reservation.lot.tax_dispositifs.filter(t => t === 'prix_maitrise')
          dispositifs = this.dispositifsChoicesRpList.filter(dispositif => lotDispositifs.includes(dispositif.value))
        }
      }
      return dispositifs
    },
    checkForNext () {
      if (this.currentStep === 1 && this.reservation.destination && this.validBuyers && this.validNotary) {
        if (this.reservation.destination === 'invest') {
          if (this.reservation.tax_dispositif) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      } else if (this.currentStep === 2) {
        return true
      } else if (this.currentStep === 3 && (this.not_using_loan || (this.reservation.funding_data.initial_loan_value && (this.reservation.funding_data.contribution_amount === 0 || this.reservation.funding_data.contribution_amount) && this.reservation.funding_data.origin_contribution && this.reservation.funding_data.initial_loan_duration && this.reservation.funding_data.initial_loan_rate))) {
        return true
      } else if (this.currentStep === 4) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    'selectedPack' (newVal) {
      if (this.fromStart || this.fromPackReselection) return
      if (newVal) {
        this.$store.commit('modifyCurrentReservation', { key: 'pack', value: newVal.pk })
      } else {
        this.$store.commit('modifyCurrentReservation', { key: 'pack', value: null })
      }
    },
    'reservation.notary_details.use_buyer_notary' (to) {
      if (this.fromStart) return
      this.$store.commit('modifyCurrentReservation', { key: 'notary_details.use_buyer_notary', value: to })
    },
    'not_using_loan' (to) {
      if (this.fromStart) {
        this.fromStart = false
        return
      }
      this.$store.commit('modifyCurrentReservation', { key: 'funding_data.use_loan', value: !to })
    },
    'reservation.destination' (to, old) {
      if (old !== undefined && to !== old) {
        this.reservation.tax_dispositif = null
      }
    },
    'reservation.tax_dispositif' (v) {
      this.error.tax = false
    },
    'reservation.funding_data.security_deposit' (to) {
      if (this.fromStart) {
        this.fromStart = false
        return
      }
      this.$store.commit('modifyCurrentReservation', { key: 'funding_data.security_deposit', value: to })
    },
    'openMentionPart' (newVal) {
      if (!newVal) {
        this.reservation.mention_comment = ''
        this.$store.commit('modifyCurrentReservation', { key: 'mention_comment', value: this.reservation.mention_comment })
        this.openWysiMention = true
        this.baseMentionComment = null
      }
    },
    quickview ({ mode, params, results }) {
      if (mode === 'CONTACT_SELECTION') {
        try {
          if (results.entities.length) {
            this.addContact(results.entities[0])
          } else {
            this.$toasted.global.danger('Veuillez sélectionner un utilisateur')
          }
        } catch (e) {
        }
      } else if (mode === 'CONTACT_CREATE' && results) {
        let check = 'CONTACT_CREATE'
        this.verifBeforeCreateContact(results.contact, check)
      } else if (mode === 'CONTACT_UPDATE' && results && params && params.fromBuyerEdit) {
        this.initContact(results.contact)
      } else if (mode === 'CONTACT_CHECK_CREATE' && results) {
        this.createContact(results.contact)
      }
    },
    modal ({ mode, params, results }) {
      if (results) {
        if (mode === 'CONTRACT_SELECT_MODAL') {
          if (results.pk == null) {
            this.$store.commit('modifyCurrentReservation', { key: 'contract_in_use', value: null })
          } else {
            this.$store.commit('modifyCurrentReservation', { key: 'contract_in_use', value: results.pk })
          }
        }
      }
    }
  },

  async created () {
    bus.$on(EVENTS.RESERVATION_PROPOSAL_REFUSED, (data) => {
      if (this.reservation.pk === data.resource_pk) {
        this.refusedReservation()
      }
    })
    this.initWidget()
  },
  destroyed () {
    bus.$off(EVENTS.RESERVATION_PROPOSAL_REFUSED)
  },
  methods: {
    /**
      * Sélection d'un notaire du référentiel : lie et remplit les champs
      * @param {object} interlocuteur - { ...interlocuteur, tiers }
      */
    selectNotaireClient (interlocuteur) {
      this.selectedNotaireClient = interlocuteur
      this.applyTiersSelection(this.writeNotaireClient, interlocuteur)
    },
    /**
      * Délier du référentiel : vide aussi les champs (anti-doublon)
      */
    unlinkNotaireClient () {
      this.selectedNotaireClient = null
      this.applyTiersUnlink(this.writeNotaireClient)
    },
    /**
      * writer(key, value) du bloc notaire client — $set d'abord pour rendre
      * réactives les clés absentes du JSON (tiers_id, interlocuteur_id)
      */
    writeNotaireClient (key, value) {
      this.$set(this.reservation.notary_details, key, value)
      this.$store.commit('modifyCurrentReservation', { key: `notary_details.${key}`, value })
    },
    /**
      * cancel button action
      */
    cancelButton () {
      if (this.pendingReservationSubmit && !this.isPending) {
        this.cancelReservation()
      } else {
        this.refuseValidation()
      }
    },
    setPercentageContribution (val) {
      this.reservation.funding_data.percentage_contribution = ((val * 100) / this.reservation.sale_price_ttc).toFixed(2)
      this.reservation.funding_data.security_deposit_value = val
      this.updateFundingData('security_deposit_value', val)
      this.updateFundingData('percentage_contribution', this.reservation.funding_data.percentage_contribution)
    },
    setSecurityDepositValue (val) {
      this.reservation.funding_data.security_deposit_value = ((this.reservation.sale_price_ttc * val) / 100).toFixed(2)
      this.reservation.funding_data.percentage_contribution = val
      this.updateFundingData('percentage_contribution', val)
      this.updateFundingData('security_deposit_value', this.reservation.funding_data.security_deposit_value)
    },
    updateFundingData (fullKey, value) {
      let key = `funding_data.${fullKey}`
      this.$store.commit('modifyCurrentAdv', { key, value })
    },
    /**
      * cancel reservation
      */
    async cancelReservation () {
      if (!(this.isPromoteur && this.isAdmin)) {
        await this.$router.goBack()
        this.$store.commit('setReservationSubmitButtons', false)
      }
    },
    /**
      * add contact
      * @param {object} contact
      */
    async addContact (contact) {
      let completeContact = await this.returnContact(contact.pk)
      this.buyers.push(completeContact)
      this.$store.commit('modifyCurrentReservation', { key: 'buyers', value: this.buyers })
      this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
    },
    /**
      * return contact
      * @return {object}
      * @param {string} id
      */
    async returnContact (id) {
      try {
        let { data } = await this.$api.getOne(this.$resources.CONTACT, id)
        return data
      } catch (err) {
        console.log(err)
      }
    },
    /**
      * confirm delete
      */
    confirmDelete () {
      return this.$swal({
        title: 'Annulation',
        text: 'Êtes vous sûr de vouloir annuler cette réservation ?',
        focusConfirm: false,
        customClass: {
          confirmButton: 'is-danger'
        }
      })
    },
    /**
      * update option
      * @param {string} id - pk
      * @param {object} data
      * @param {string} text
      */
    async updateOption (id, data, text) {
      try {
        let request = await this.$api.patch(this.$resources.OPTION, id, data)
        this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
        await this.$store.dispatch('fetchOption', request.data.pk)
        this.$router.replace({ name: 'OptionList' })
        this.$toasted.global.success(text)
      } catch (err) {
        console.log(err)
        this.$toasted.global.danger('Erreur lors de la modification de la réservation')
      }
    },
    /**
      * cancel option
      */
    cancelOption () {
      this.confirmDelete().then(r => {
        if (r.value) {
          this.updateOption(this.reservation.option.pk, { status: 'canceled' }, 'L\'option a été annulée.')
        }
      })
    },
    /**
      * update sale price ttc
      * @param {number} valSalePrice
      */
    updateSalePrice: debounce(function (valSalePrice) {
      let salePriceTTC, salePriceHT
      if (this.reservation.tva === null) {
        this.reservation.sale_price_ttc = Number(valSalePrice)
        return this.reservation.sale_price_ttc
      } else if (!this.reservation.sale_price_ttc || Number(valSalePrice) !== Number(this.reservation.sale_price_ttc)) {
        salePriceTTC = valSalePrice
        salePriceHT = salePriceTTC / (1 + (this.reservation.tva / 100))
        salePriceHT = salePriceHT.toFixed(2)
      }
      this.updatePrice(salePriceTTC, salePriceHT)
    }, 500),
    /**
      * update sale price ht
      * @param {number} valSalePriceHt
      */

    updateSalePriceHt: debounce(function (valSalePriceHt) {
      let salePriceTTC, salePriceHT
      if (this.reservation.tva === null) {
        this.reservation.sale_price_ht = Number(valSalePriceHt)
        return this.reservation.sale_price_ht
      } else if (!this.reservation.sale_price_ht || Number(valSalePriceHt) !== Number(this.reservation.sale_price_ht && this.reservation.tva !== 'NAN')) {
        salePriceHT = valSalePriceHt
        salePriceTTC = salePriceHT * (1 + (this.reservation.tva / 100))
        salePriceTTC = salePriceTTC.toFixed(2)
      }
      this.updatePrice(salePriceTTC, salePriceHT)
    }, 500),
    /**
      * update price
      * @param {number} salePriceTTC
      * @param {number} salePriceHT
      */
    updatePrice (salePriceTTC, salePriceHT) {
      if (salePriceTTC) this.$store.commit('modifyCurrentReservation', { key: 'sale_price_ttc', value: salePriceTTC })
      if (salePriceHT) this.$store.commit('modifyCurrentReservation', { key: 'sale_price_ht', value: salePriceHT })
      this.$set(this, 'tvaAmount', Number(this.reservation.sale_price_ttc) - Number(this.reservation.sale_price_ht))
    },
    /**
      * update tva
      * @param {number} tva
      */
    updateTva (val) {
      let salePriceTTC, salePriceHT
      salePriceTTC = Number(this.reservation.sale_price_ttc)
      salePriceHT = Number(this.reservation.sale_price_ht)
      if (val !== 'autre') {
        if (val) this.$set(this.reservation, 'tva', val)
        let tva = this.reservation.tva
        salePriceTTC = salePriceHT * (1 + (tva / 100))
        salePriceTTC = salePriceTTC.toFixed(2)
      } else if (val === 'autre') {
        this.getTva = ((salePriceTTC - salePriceHT) / salePriceHT) * 100
        this.$set(this.reservation, 'tva', null)
      }
      if (salePriceTTC === 'NaN') salePriceTTC = null
      if (salePriceHT === 'NaN') salePriceHT = null
      this.updatePrice(salePriceTTC, salePriceHT)
    },
    /**
      * open ticket modal
      */
    openModalTicket () {
      let params = {
        defaultSubject: 'lot_information',
        defaultTitle: 'Lot ' + this.reservation.lot.ref + ' - Programme ' + this.reservation.program.name,
        promoteur: this.reservation.promoteur.pk
      }
      this.$store.commit('setModal', { mode: 'CREATE_TICKET', params })
    },
    /**
       * after refused reservation
       */
    refusedReservation () {
      this.$router.replace({ name: 'OptionList' })
    },
    /**
       * init widget
       */
    async initWidget () {
      this.fromStart = true
      await this.getReservation()
      if (!this.tvaList.includes(this.reservation.tva)) {
        await this.tvaList.push(this.reservation.tva)
      }
      if (this.reservation) {
        if (this.reservation.seller_remuneration) {
          this.reservation.remuneration = this.reservation.seller_remuneration
          // this.$store.commit('modifyCurrentReservation', { key: 'remuneration', value: this.reservation.seller_remuneration})
        } else if (this.program.remuneration) {
          this.reservation.remuneration = this.program.remuneration
          // this.$store.commit('modifyCurrentReservation', { key: 'remuneration', value: this.program.remuneration })
        } else {
          this.reservation.remuneration = null
        }
        if (this.reservation.funding_data.use_loan === null) {
          this.not_using_loan = false
        } else if (this.reservation.funding_data.use_loan === true) {
          this.not_using_loan = !this.reservation.funding_data.use_loan
        } else {
          this.fromStart = true
          this.not_using_loan = !this.reservation.funding_data.use_loan
        }
        if (!this.reservation.mention_comment) {
          return
        } else {
          this.openMentionPart = true
        }
      }
      // this.updateNotUsingLoans()
      this.fromStart = false
    },
    /**
       * update not_using_loan
       */
    // updateNotUsingLoans () {
    //   if (this.reservation.funding_data.use_loan === null) {
    //     this.not_using_loan = false
    //   } else {
    //     this.not_using_loan = !this.reservation.funding_data.use_loan
    //   }
    // },
    /**
       * get reservation
       */
    async getReservation () {
      this.loading = true
      try {
        let { data } = await this.$api.getOne(this.$resources.RESERVATION, this.reservationPk)
        this.$store.commit('setCurrentReservation', { reservation: data })

        this.reservation = data
        this.baseComment = data.comment
        this.openWysi = !this.reservation.comment
        this.openWysiMention = !this.reservation.mention_comment

        this.buyers = data.buyers.slice()
        this.option = Object.assign({}, data.option)
        this.seller = Object.assign({}, data.user)
        if (this.isPreReserved) {
          this.$router.replace({ name: 'AdvInfos', params: { id: data.pk } })
        } else {
          if (data.sale_date) {
            this.sale_date = moment(data.sale_date).format('YYYY-MM-DD')
          }
          if (data.sale_date) {
            this.sale_date = moment(data.sale_date).format('YYYY-MM-DD')
          }
          if (this.isPending) {
            this.pendingRemuneration = data.remuneration
          }
          this.signed_contract = data.signed_contract
          await this.getLot()
          await this.getProgram()
          await this.getPackList()
          this.fromPackReselection = false
        }
      } catch (err) {
        this.loading = false
        console.log(err)
      }
    },
    /**
       * get lot
       */
    async getLot () {
      this.loading = true
      try {
        let request = await this.$api.getOne(this.$resources.LOT, this.reservation.lot.pk)
        this.lot = request.data
        this.parkings = request.data.parkings
        let newReservationParkings = []
        let reservationParkingsPk = this.reservation.parkings.map(x => x.pk)
        for (let parking of this.parkings) {
          this.checkParking[parking.pk] = false
          if (reservationParkingsPk && reservationParkingsPk.includes(parking.pk)) {
            this.reservation.parkings.map(x => {
              if (x.pk === parking.pk) {
                this.checkParking[parking.pk] = true
                newReservationParkings.push(parking)
              }
            })
          }
        }
        this.reservation.parkings = newReservationParkings
        this.loading = false
      } catch (err) {
        console.log(err)
        this.loading = false
      }
    },
    /**
       * get program
       */
    async getProgram () {
      this.loading = true
      try {
        let request = await this.$api.getOne(this.$resources.PROGRAM, this.reservation.program.pk)
        this.program = request.data
        if ('rep_address' in request.data.promoteur_data) {
          this.companyAddress = Object.assign({}, request.data.promoteur_data.rep_address)
        }
        this.loading = false
      } catch (err) {
        console.log(err)
        this.loading = false
      }
    },
    /**
       * get pack list
       */
    async getPackList () {
      this.loading = true
      try {
        let request = await this.$api.axios.get(`lots/${this.lot.pk}/packs`)
        this.packList = request.data.items

        if (this.reservation.pack) {
          this.fromPackReselection = true
          this.selectedPack = this.packList.find(x => x.pk === this.reservation.pack.pk)
        }

        this.loading = false
      } catch (err) {
        console.log(err)
        this.loading = false
      }
    },
    /**
       * open buyer selection
       */
    openBuyerSelection () {
      let buyersPk = this.buyers.map(x => x.pk)
      let params = {
        facets: {
          CONTACT: []
        },
        mode: 'store'
      }
      for (let exclude of buyersPk) {
        params.facets.CONTACT.push([`pk:-${exclude}`])
      }
      this.openContactSelectionQuickview({ params })
    },
    /**
       * confirm modal delete buyer
       */
    confirmDeleteBuyer () {
      return this.$swal({
        title: 'Suppression co-acquéreur',
        text: 'Souhaitez-vous vraiment retirer ce co-acquéreur ?',
        confirmButtonText: 'Supprimer',
        focusConfirm: false
      })
    },
    /**
       * delete buyer
       * @param {object} buyer
       */
    async deleteBuyer (buyer) {
      let value = await this.confirmDeleteBuyer()
      if (value.dismiss) return false // ON ne supprimme pas l'utilisateur
      if (value) {
        let index = this.buyers.findIndex(x => x.pk === buyer.pk)
        if (index >= 0) {
          this.buyers.splice(index, 1)
          this.$store.commit('modifyCurrentReservation', { key: 'buyers', value: this.buyers })
          this.$toasted.global.success('L\'acquéreur a été supprimé.')
        }
      }
    },

    confirmDeleteDocument () {
      return this.$swal({
        title: 'Suppression document',
        html: 'Souhaitez-vous supprimer définitivement ce document ?<p>Attention, il sera également supprimé définitivement de la fiche du contact.</p><p><i>(Vous pouvez désaffecter le document de votre demande de réservation depuis la fiche du contact.)</i></p>',
        confirmButtonText: 'Supprimer',
        focusConfirm: false
      })
    },

    async deleteDocument (document) {
      let value = await this.confirmDeleteDocument()
      if (value.dismiss) return false
      if (value) {
        let index = this.buyers.findIndex(buyer =>
          buyer.documents.some(doc => doc.fus_id === document.fus_id)
        )
        if (index >= 0) {
          let documentIndex = this.buyers[index].documents.findIndex(doc => doc.fus_id === document.fus_id)
          if (documentIndex !== -1) {
            this.buyers[index].documents.splice(documentIndex, 1)
          }
          try {
            let { data } = await this.$api.getOne(this.$resources.CONTACT, this.buyers[index].pk)
            let documentIndex = data.documents.findIndex(doc => doc.fus_id === document.fus_id)
            if (documentIndex !== -1) {
              data.documents.splice(documentIndex, 1)
            }
            const cleanContact = this.$cleanPayload(data)
            if (Array.isArray(cleanContact.programs) && isObject(cleanContact.programs[0])) {
              cleanContact.programs = [cleanContact.programs[0].pk]
            }
            if (cleanContact.original_program && cleanContact.original_program.pk) {
              cleanContact.original_program = cleanContact.original_program.pk
            }
            await this.$api.put(this.$resources.CONTACT, data.pk, cleanContact)
            this.$toasted.global.success('Document supprimé')
          } catch (err) {
            console.log(err)
          }
          this.$store.commit('modifyCurrentReservation', { key: 'buyers', value: this.buyers })
        }
      }
    },
    /**
       * create contact
       * @param {object} contact
       */
    async verifBeforeCreateContact (contact, check) {
      this.$store.commit('setQuickviewLoading', true)
      if (this.seller && this.seller.account.pk === this.currentUser.account.pk) {
        contact.user = this.seller.pk
      } else {
        contact.user = this.currentUser.pk
      }
      if (contact.last_name === null || contact.last_name === '') {
        this.$toasted.global.danger('Veuillez renseignez un nom au contact')
        this.$store.commit('setQuickviewLoading', false)
        return
      }

      if (contact.first_name === null || contact.first_name === '') {
        this.$toasted.global.danger('Veuillez renseignez un prénom au contact')
        this.$store.commit('setQuickviewLoading', false)
        return
      }

      try {
        this.$store.commit('setQuickviewLoading', false)
        let contactUser = null
        if (this.seller && this.seller.pk) {
          contactUser = this.seller.pk
        } else {
          contactUser = contact.user
        }
        let payload = {
          contact: this.$cleanPayload(contact),
          user: contactUser
        }
        let { data } = await this.$api.post(this.$resources.CONTACT_CHECK, payload)
        if (data.duplicates.length !== 0 || data.all_pk_contact.length !== 0) {
          data.duplicates.length !== 0 ? this.duplicateDenunciation = true : this.duplicateDenunciation = false
          data.all_pk_contact.length !== 0 ? this.duplicateContact = true : this.duplicateContact = false
          let alert = true
          this.openNewContactQuickview({}, contact, alert, data)
        } else {
          this.createContact(contact)
        }
      } catch (e) {
        this.loading = false
        this.$store.commit('setQuickviewLoading', false)
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
      }
    },
    async createContact (contact) {
      this.duplicateContact = this.duplicateContact === true ? contact.doublon_contact = true : contact.doublon_contact = false
      this.duplicateDenunciation = this.duplicateDenunciation === true ? contact.doublon_denunciation = true : contact.doublon_denunciation = false
      // let contactUser = null
      // if (contact.user) {
      //   contactUser = contact.user.pk
      // } else {
      //   contactUser = this.currentUser.pk
      // }
      // let payload = {
      //   contact: this.$cleanPayload(contact),
      //   user: contactUser
      // }
      // let { data } = await this.$api.post(this.$resources.CONTACT_CHECK, payload)
      // if (data.duplicates.length !== 0 || data.all_pk_contact.length !== 0) {
      //   contact.doublon = true
      // }
      // if (this.seller) {
      //   contact.user = this.seller.pk
      // }
      try {
        let { data } = await this.$api.post(this.$resources.CONTACT, this.$cleanPayload(contact))
        data = data.json_data
        this.buyers.push(data)
        this.$store.commit('modifyCurrentReservation', { key: 'buyers', value: this.buyers })
        this.$toasted.global.success('Contact ajouté')
        this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
      } catch (e) {
        console.log(e)
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
      }
    },
    /**
       * init parking
       */
    initParking () {
      let selectedParkings = []
      for (let parking in this.checkParking) {
        if (this.checkParking[parking]) {
          let filteredParking = this.parkings.filter(x => x.pk === parking)
          selectedParkings.push(filteredParking[0])
        }
      }
      this.$store.commit('modifyCurrentReservation', { key: 'parkings', value: selectedParkings })
    },
    /**
       * submit reservation
       */
    submitReservation () {
      if (this.pendingReservationSubmit) {
        this.putReservation()
      } else if (!(this.isAdmin && this.isPromoteur) && !this.pendingReservationSubmit && !this.program.pre_reserved_auto) {
        this.askValidation()
      } else {
        this.approveValidation()
      }
    },
    /**
       * verification submit
       * @param {boolean} validBuyerCheck
       */
    async verificationSubmit (validBuyerCheck = true) {
      let reservation = Object.assign({}, this.reservation)
      if (!reservation.destination) {
        this.error.destination = true
        this.submitLoading = false
        this.$toasted.global.danger('Oups ! Merci de compléter les champs obligatoires.')
        return false
      }
      if (reservation.destination && reservation.destination === 'invest' && !reservation.tax_dispositif) {
        this.error.tax = true
        this.submitLoading = false
        this.$toasted.global.danger('Oups ! Merci de compléter les champs obligatoires.')
        return false
      }
      if (this.currentStep !== 1) {
        if (!this.validFinancementPreResa) {
          this.$toasted.global.danger('Informations financement incomplétes ou erronées')
          this.submitLoading = false
          return false
        }
      }
      if (!this.validBuyers && validBuyerCheck) {
        this.$toasted.global.danger('Informations acquéreur(s) incomplétes ou erronées')
        this.submitLoading = false
        return false
      }
      if (!this.pendingReservationSubmit && !this.isValid) {
        this.$toasted.global.danger('Demande de pré-réservation incompléte, vous pouvez vous rapprocher de l\'administrateur')
        let error = await this.$api.get(`/reservations/${this.reservationPk}/check`)
        console.log(error)
        this.submitLoading = false
        return false
      }
      if (this.isPromoteurAdmin && (reservation.remuneration < 0)) {
        this.$toasted.global.danger('Veuillez renseigner un taux de commercialisation')
        this.submitLoading = false
        return false
      }
      if (this.amountTva > 20 || this.amountTva < 0) {
        this.$set(this.reservation, 'tva', this.amountTva)
      }
      return true
    },
    /**
       * put reservation
       */
    async putReservation () {
      this.submitLoading = true
      let verification = await this.verificationSubmit(false)
      if (!verification) return
      try {
        await this.$store.dispatch('updateCurrentReservation')
        this.submitLoading = false
        this.$toasted.global.success('Reservation modifiée')
        this.getReservation()
        return true
      } catch (e) {
        this.submitLoading = false
        this.$toasted.global.danger('Erreur lors de la mise à jour')
        return false
      }
    },
    /**
       * get contract url
       */
    async getContractUrl () {
      const request = await this.$api.getReservationContract(this.reservationPk)
      const win = window.open(request.data, '_blank')
      win.focus()
    },
    /**
       * ask validation
       */
    async askValidation () {
      let verification = await this.verificationSubmit()
      if (!verification) return
      let value = await this.$swal({
        title: 'Demande validation pré-réservation',
        text: 'L\'ensembles des données renseignées vont être transmises au promoteur pour vérifications.',
        cancelButtonText: 'Annuler',
        confirmButtonText: 'Valider',
        customClass: {
          confirmButton: 'is-danger'
        }
      })
      if (value.dismiss) return false
      if (value) {
        this.loadSubmitAsk = true
        await this.updateStatus('pending')
      }
    },
    /**
       * confirm validation
       */
    async approveValidation () {
      // je passe ici
      let verification = await this.verificationSubmit()
      if (!verification) return
      let value = await this.$swal({
        title: 'Valider le dossier de pré-réservation',
        text: 'La validation de la demande entrainera le passage en pré-réservation du lot. Le lot sera visible par vos vendeurs et prescripteurs mais non optionnable.',
        cancelButtonText: 'Annuler',
        confirmButtonText: 'Valider',
        customClass: {
          confirmButton: 'is-danger'
        }
      })
      if (value.dismiss) return false
      if (value) {
        this.loadSubmitValidation = true
        if ((this.isOptionUser || this.isAdminUser || this.isManagerUser || this.isContactSharedByPromoteur) && ((this.isAdmin && this.isPromoteur) || (!(this.isAdmin && this.isPromoteur) && this.program.pre_reserved_auto)) && this.reservation.status !== 'pending') {
          this.forceLoading = true
          await this.updateStatus('pending')
        }
        await this.updateStatus('pre_reserved')
      }
    },
    /**
       * refuse validation
       */
    async refuseValidation () {
      let value = await this.$swal({
        title: 'Refuser le dossier de pré-réservation',
        text: 'Le refus de pré-réservation entrainera l\'annulation de la demande de pré-réservation. Le lot restera optionné par le commercialisateur, il pourra vous soumettre un nouveau dossier s\'il le souhaite.',
        cancelButtonText: 'Annuler',
        confirmButtonText: 'Valider',
        customClass: {
          confirmButton: 'is-danger'
        }
      })
      if (value.dismiss) return false
      if (value) {
        this.loadSubmitRefuse = true
        await this.updateStatus('refused')
        this.refusedReservation()
      }
    },
    /**
       * update status
       * @param {string} status
       */
    async updateStatus (status) {
      try {
        let request = await this.$api.updateReservationStatus(this.reservationPk, status)
        this.reservation.status = request.data.status
        if (status === 'pre_reserved') {
          this.$router.replace({ name: 'AdvInfos', params: { id: request.data.pk } })
        } else if (status === 'pending') {
          // this.$router.goBack()
        } else {
          this.getReservation()
        }
        this.loadSubmitAsk = false
        this.loadSubmitValidation = false
        this.loadSubmitRefuse = false
      } catch (e) {
        this.$toasted.global.danger('Impossible de mettre à jour la réservation.')
        this.loadSubmitAsk = false
        this.loadSubmitValidation = false
        this.loadSubmitRefuse = false
      }
    },
    /**
       * open wysiwyg
       */
    openWysiwyg (v = false) {
      let isForMention = v
      if (isForMention) {
        this.openWysiMention = true
      } else {
        this.openWysi = true
      }
      // this.$nextTick(() => {
      //   let selection = document.getSelection()
      //   let range = document.createRange()
      //   let contenteditable = document.getElementsByClassName('ql-editor')
      //   contenteditable = contenteditable[this.idx]
      //   if (contenteditable.lastChild.nodeType === 3) {
      //     range.setStart(contenteditable.lastChild, contenteditable.lastChild.length)
      //   } else {
      //     range.setStart(contenteditable, contenteditable.childNodes.length)
      //   }
      //   selection.removeAllRanges()
      //   selection.addRange(range)
      // })
    },
    async openPreviewContractSelect () {
      let params = {
        source: {
          contracts: this.program.contracts,
          currentContract: this.reservation.contract_in_use
        }
      }
      this.$store.commit('setModal', { mode: 'CONTRACT_SELECT_MODAL', params })
    },
    remunerationInput (val) {
      if (val === '') {
        this.$store.commit('modifyCurrentReservation', { key: 'seller_remuneration', value: null })
      } else {
        this.$store.commit('modifyCurrentReservation', { key: 'seller_remuneration', value: val })
      }
    },
    updateCheckParking ({ pk, newValue }) {
      this.checkParking = {
        ...this.checkParking,
        [pk]: newValue
      }
      this.initParking()
    },
    notUsingLoanUpdate (newValue) {
      this.not_using_loan = newValue
      this.fromStart = false
    },
    nextStep () {
      if (this.currentStep === 1 && this.reservation.destination && this.validBuyers) {
        if (this.currentStep < 4) {
          this.currentStep++
        }
      } else if (this.currentStep === 2) {
        if (this.currentStep < 4) {
          this.currentStep++
        }
      } else if (this.currentStep === 3 && (this.not_using_loan || (this.reservation.funding_data.initial_loan_value && (this.reservation.funding_data.contribution_amount === 0 || this.reservation.funding_data.contribution_amount) && this.reservation.funding_data.origin_contribution && this.reservation.funding_data.initial_loan_duration && this.reservation.funding_data.initial_loan_rate))) {
        if (this.currentStep < 4) {
          this.currentStep++
          if (this.pendingReservationSubmit) {
            this.putReservation()
          }
        }
      } else {
      }
    },
    previousStep () {
      if (this.currentStep > 1) {
        this.currentStep--
      }
    },
    async openModalContactPreResaInfo (buyer, index) {
      let { data } = await this.$api.getOne(this.$resources.CONTACT, buyer.pk)
      this.$store.commit('setQuickview', {
        mode: 'CONTACT_UPDATE',
        params: {
          contact: { ...data },
          replaceBuyer: true,
          index,
          fromBuyerEdit: true
        }
      })
    },
    async initContact (contact) {
      try {
        const cleanContact = this.$cleanPayload(contact)
        if (Array.isArray(cleanContact.programs) && cleanContact.programs.length && typeof cleanContact.programs[0] === 'object') {
          cleanContact.programs = [cleanContact.programs[0].pk]
        }
        if (cleanContact.original_program && cleanContact.original_program.pk) {
          cleanContact.original_program = cleanContact.original_program.pk
        }
        // Préserver le vendeur référent : le back attend `user` en pk, pas un objet.
        // Sans ça, le référent est effacé et l'option (donc la réservation) est annulée.
        if (cleanContact.user && cleanContact.user.pk) {
          cleanContact.user = cleanContact.user.pk
        } else {
          delete cleanContact.user
        }
        await this.$api.put(this.$resources.CONTACT, contact.pk, cleanContact)
        this.$toasted.global.success('Contact modifié')
      } catch (e) {
        console.log(e)
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
        return
      }
      const index = this.buyers.findIndex(buyer => buyer.pk === contact.pk)
      if (index !== -1) {
        // A TROUVER UN AUTRE MOYEN (me permet d'afficher a true les membre-adv + etape suivante au lieu de refresh la page)
        contact.is_complete = true
        this.$set(this.buyers, index, contact)
      }
      this.$store.commit('modifyCurrentReservation', { key: 'buyers', value: this.buyers })
      this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
    }
  }
}
</script>
